module.exports = __webpack_public_path__ + "static/media/skila-bg_img-02-3-pod_600px_width-0_1-@3x.c9928572.png";